<template>
  <div class="d-flex">
    <div class="mapTooltips my-3">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon @click="refreshMap = !refreshMap" v-on="on">
            <v-icon>
              mdi-refresh
            </v-icon>
          </v-btn>
        </template>
        <span>
          {{ generateMessage('tech_search.cardView.switch.refresh') }}
        </span>
      </v-tooltip>
    </div>
    <technician-selector-map
      class="mapContainer my-3"
      @click="setTechnicianDisplayed"
      :displayedTechId="technicianDisplayed.id"
      :request="request"
      :technicians="localizedInterventions"
      :specialTechnicians="specialTechnicians"
      :refresh="refreshMap"
    />
    <technician-cards-list
      class="cardsCol my-3"
      @display="setTechnicianDisplayed"
      :displayedTechId="technicianDisplayed.id"
      :isPropertyOrdo="isPropertyOrdo"
      :request="{ ...request, propertyAdress: propertyAdress }"
      :specialTechnicians="specialTechnicians"
      :technicians="globalStaff"
    />
    <div class="infosCol pa-3">
      <custom-property-details
        :isPropertyOrdo="isPropertyOrdo"
        :item="{ ...request, propertyAdress: propertyAdress }"
        v-if="technicianDisplayed.id === 0"
      />
      <custom-technician-details
        :affectedTech="affectedTech"
        @input="assignTech"
        :request="request"
        :item="technicianDisplayed"
        :specialTechnicians="specialTechnicians"
        v-if="technicianDisplayed.id > 0"
        :affectation="affectation"
      />
    </div>
  </div>
</template>

<script>
import CustomPropertyDetails from '@/components/displays/CustomPropertyDetails';
import CustomTechnicianDetails from '@/components/displays/CustomTechnicianDetails';
import { generateMessage } from '@/utils/i18n';
import TechnicianCardsList from '@/components/selects/technician/TechnicianCardsList';
import TechnicianSelectorMap from '@/components/maps/TechnicianSelectorMap';

export default {
  name: 'CustomTechnicianSelectorMap',
  components: {
    CustomPropertyDetails,
    CustomTechnicianDetails,
    TechnicianCardsList,
    TechnicianSelectorMap,
  },
  props: {
    affectedTech: { type: Object, required: false },
    filteredStaff: { type: Array, required: true },
    request: { type: Object, required: true },
    specialTechnicians: { type: Object, required: true },
    affectation: { type: Boolean, required: false, default: true },
    interventions: { type: Array, required: true },
  },
  computed: {
    globalStaff() {
      return this.interventions.concat(
        this.filteredStaff
          .filter((tech) =>
            this.interventions.every((item) => item.id !== tech.id)
          )
          .map((tech) => ({ ...tech, planification: null }))
      );
    },
    /* interventions() {
      return this.$store.getters[
        'technicians/interventions/items'
      ].filter((item) =>
        this.filteredStaff.some((tech) => tech.id === item.id)
      );
    }, */
    isPropertyOrdo() {
      return (
        this.request.transformable_request &&
        this.request.transformable_request === 'O'
      );
    },
    localizedInterventions() {
      return this.interventions.filter(
        (item) => item.intervention_longitude && item.intervention_latitude
      );
    },
    propertyAdress() {
      let value = '';
      this.adressFields.forEach((field) => {
        value += this.request[field] ? `${this.request[field]} ` : '';
      });
      return value;
    },
  },
  watch: {
    affectedTech(newVal) {
      this.technicianDisplayed = newVal && newVal.id ? newVal : { id: -1 };
      this.highlightElement(this.technicianDisplayed.id);
    },
  },
  data() {
    return {
      adressFields: ['street_number', 'street', 'postal_code', 'town'],
      technicianDisplayed: { id: -1 },
      refreshMap: false,
    };
  },
  methods: {
    assignTech(event) {
      this.$emit(
        'input',
        this.filteredStaff.find((item) => item.id === event.id)
      );
    },
    generateMessage,
    highlightElement(id) {
      if (id >= 0) {
        const element = document.getElementById(`techCard-${id}`);
        if (element)
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },
    setTechnicianDisplayed(tech) {
      this.technicianDisplayed = tech;
    },
  },
};
</script>

<style scoped>
.mapTooltips {
  width: min-content;
}
.mapContainer {
  height: 57vh;
  width: 46%;
}
.cardsCol,
.infosCol {
  height: 57vh;
  overflow-y: auto;
  width: 27%;
}
</style>
